import { EpimsBaseEntityDto } from './epim-base.dto';
import { CorrespondenceRequestTypeDto } from './correspondence-request-type.dto';

export class CorrespondenceRequestCategoryDto extends EpimsBaseEntityDto {
  CorrespondenceRequestCategoryName: string;
  AccountableFunctionId: string;
  requestTypes?: CorrespondenceRequestTypeDto[];
}
